export interface QuestionI {
  analysis: string;
  answer: string; // '[1,0,0]/参考答案';
  assignmentId: string;
  id: string;
  metas: string; // '[A选项内容,B选项内容,C选项内容]';
  moduleId: string;
  questionType: 0; // 题目类型 0-单选题, 1-多选题,2-判断题,3-填空题 ,
  score: number;
  seq: number;
  stem: string; // '题干';
}

export class PMeta {
  uid = ''

  meta = ''
}

export interface ParseQuestionI {
  analysis: string;
  answer: string; // '[1,0,0]/参考答案';
  pAnswer: Array<number|string|boolean|undefined>;
  assignmentId: string;
  id: string;
  metas: string; // '[A选项内容,B选项内容,C选项内容]';
  pMetas: PMeta[];
  moduleId: string;
  questionType: 0; // 题目类型 0-单选题, 1-多选题,2-判断题,3-填空题 ,
  score: number;
  seq: number;
  stem: string; // '题干';
}
export interface StuParseQuestionI extends ParseQuestionI {
  stuAnswer?: string; // '[1,0,0]' 学生答案
  pStuAnswer?: Array<number|string|boolean|undefined>;
  stuScore?: number; // 学生改题得分
  stuTrue?: boolean; // 学生是否做对了
  blankNumber?: number; // 教师的评分状态 —— 题目的
}

export class Question {
    analysis = '';

    answer = '[0]'; // '[1,0,0]/参考答案';

    assignmentId = '';

    id = '';

    metas = '[]'; // '[A选项内容,B选项内容,C选项内容]';

    moduleId = '';

    questionType = 0; // 题目类型 0-单选题, 1-多选题,2-判断题,3-填空题 ,

    score = 1; // 需求：分数1~20

    seq = 0;

    stem = ''; // '题干';
}
export class QuestionStu extends Question {
  stuAnswer?: string = undefined;
}

/** 用来initQueston弹框的类 */
export class QuestionInit extends Question {
  uid?: string

  pAnswer?: Array<number|string|boolean|undefined>;

  pMetas?: PMeta[];

  isChecked?: boolean;

  constructor() {
    super();
    delete this.uid;
    delete this.pAnswer;
    delete this.isChecked;
    // this.pAnswer = undefined;
    // this.pMetas = undefined;
    // this.isChecked = undefined;
  }
}
